import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const metricsApi = {
  /**
   * Fetches metric data for a user.
   * @apiRoute GET '/metrics'
   */
  async getUserMetrics(userId) {
    try {
      const response = await apiGet(
        getPath('metrics'),
        new URLSearchParams({ userId })
      );
      return response.data;
    } catch (err) {
      await handleApiError(
        err,
        'getUserMetrics',
        true,
        'Failed to fetch user metrics'
      );
    }
  },

  /**
   * Pushes updated metric state to the local dev metrics store.
   * @apiRoute POST '/metrics/local'
   */
  async updateLocalMetrics(userId, metrics) {
    try {
      const response = await apiPost(getPath('metrics/local'), {
        userId,
        daily_complete: metrics.dailyComplete,
        weekly_complete: metrics.weeklyComplete,
        monthly_complete: metrics.monthlyComplete,
        daily_wip: metrics.dailyWip,
        weekly_wip: metrics.weeklyWip,
        monthly_wip: metrics.monthlyWip,
        daily_assigned: metrics.dailyAssigned,
        weekly_assigned: metrics.weeklyAssigned,
        monthly_assigned: metrics.monthlyAssigned,
        prev_week_complete: metrics.prevWeeklyComplete,
        prev_month_complete: metrics.prevMonthlyComplete,
        prev_week_wip: metrics.prevWeeklyWip,
        prev_month_wip: metrics.prevMonthlyWip,
        prev_week_assigned: metrics.prevWeeklyAssigned,
        prev_month_assigned: metrics.prevMonthlyAssigned,
        current_streak: metrics.dailyGoalStreak,
        projected_daily_pace: metrics.projected_daily_pace,
      });
      return response.data;
    } catch (err) {
      await handleApiError(err, 'updateLocalMetrics');
    }
  },

  /**
   * Looks up the holiday name for a given date.
   * @apiRoute GET '/metrics/holidayLookup'
   */
  async getHolidayForDate(date) {
    try {
      const response = await apiGet(
        getPath('metrics/holidayLookup'),
        new URLSearchParams({ date })
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'getHolidayForDate');
    }
  },
};
